module.exports = __webpack_public_path__ + "static/media/Jeida3.86dc16f1.jpg";